export class TerminalDto {
  terminalId: string;
  displayName: string;
  description: string;
  isProxy: boolean;
  timeZoneId: string;
}
